import { render, staticRenderFns } from "./ExtensionInfo.vue?vue&type=template&id=6ffad879&scoped=true&"
import script from "./ExtensionInfo.vue?vue&type=script&lang=ts&"
export * from "./ExtensionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffad879",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
